export type DataProvider = {
  getList: (
    resource: string,
    params: {
      pagination: { page: number; perPage: number };
      sort: { field: string; order: string };
      filter: any;
    }
  ) => Promise<{ data: any[] }>;
};

export type ListParamsFromUrl = {
  sort: { field: string; order: "ASC" | "DESC" };
  filter: Record<string, any>;
};

export const getListParamsFromHash = (
  defaults: {
    sortField?: string;
    sortOrder?: "ASC" | "DESC";
  } = {}
): ListParamsFromUrl => {
  const hash = window.location.hash || "";
  const queryString = hash.includes("?") ? hash.split("?")[1] : "";
  const params = new URLSearchParams(queryString);

  // --- SORT ---
  const field = params.get("sort") || defaults.sortField || "UserCreateDate";

  const order =
    (params.get("order") || defaults.sortOrder || "ASC").toUpperCase() ===
    "DESC"
      ? "DESC"
      : "ASC";

  // --- FILTER ---
  let filter: Record<string, any> = {};
  const filterParam = params.get("filter");

  if (filterParam) {
    try {
      filter = JSON.parse(filterParam);
    } catch {
      console.warn("Could not parse filter from URL:", filterParam);
      filter = {};
    }
  }

  // keep logs for staging/debugging
  console.log("[Exporter params]", { field, order, filter });

  return {
    sort: { field, order },
    filter,
  };
};

export const getHashQueryParams = () => {
  const hash = window.location.hash || "";

  // "#/gilders?filter=...&sort=UserCreateDate"
  const queryString = hash.includes("?") ? hash.split("?")[1] : "";

  return new URLSearchParams(queryString);
};